import { pathToModuleStyle } from '@spotify/confidence-core-react';
import { AttachmentFragment } from '@spotify/confidence-graphql';

const EXTERNAL_DOCUMENT_LABEL = 'external document';

export const isExternalLink = (uri: string): boolean =>
  /^https?:\/\//i.test(uri);

export const isContextArtifact = (artifact: AttachmentFragment): boolean =>
  isExternalLink(artifact.uri) ||
  pathToModuleStyle(artifact.uri)?.label?.toLowerCase() ===
    EXTERNAL_DOCUMENT_LABEL;
